import React from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../../Components/Sidebar/Sidebar';
import Footer from '../../Components/Footer/Footer';
import facilities from '../../config/facilities.json';
import styles from './Home.module.css';

function Home() {
  return (
    <div>
      <div className="pageWithSidebar">
        <div className="mainContent">
          <h1>Welcome to the Foundations Health Solutions Picture Project!</h1>
          <p>
            Please find the link below or use the search bar on the right to
            find the form for your respective facility.
          </p>
          <ul className={styles.facilitiesContainer}>
            {facilities.map((facility) => (
              <Link key={facility.id} to={`/${facility.id}`}>
                <li>{facility.name}</li>
              </Link>
            ))}
          </ul>
        </div>
        <Sidebar />
      </div>
      <Footer />
    </div>
  );
}

export default Home;
